/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const createTransactionContext = React.createContext({});
export let createTransactionMachine: any;

const MODULE_NAME = 'machines.createTransaction';
const log: any = LoggerModule?.getInstance();

export const useSMcreateTransaction = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createTransactionMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createTransactionMachine);

  return {
    createTransactionMachine,
    createTransactionState: state,
    createTransactionSend: send,
  };
};
